export const cols = [ 
    {
      Header: "KEY",
      accessor: "key"
    },
    {
      Header: "VALUE",
      accessor: "value"
    }
];